import React, {useEffect, useState} from 'react';
import {apiAccess} from "../../../common/components/AxiosWrapper";
import Constants from "../../../common/components/constants";
import Spinner from "../Spinner/Spinner";
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, InputAdornment, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import CreateIcon from '@mui/icons-material/Create';


function YouTube(props) {
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isEnableOpen, setEnableModalParam] = useState(false);
    const [isDisableOpen, setDisableModalParam] = useState(false);
    const [isAlertOpen, setAlertModalParam] = useState(false);
    const [isCreateOpen, setCreateModalParam] = useState(false);
    const [contentId, setContentId] = useState(null)
    const [channelIdInput,setChannelIdInput] = useState("")

    const [errorMessage,setErrorMessage] = useState("");


    useEffect(() => {
        loadFacebookList();
    }, [])
    /**
     * Youtubeの読み込み　
     */
    const loadFacebookList = () => {
        setLoading(true)
        apiAccess.get(
            Constants.URLs.GET_YOUTUBE_CHANNEL)
            .then((response) => {
                const successJson = response.data;
                setLoading(false)
                setList(successJson?.data ?? []);
            })
            .catch((error) => {
                console.log(error);
            });
    }


    const toggleItemChange = (bool) => {
        apiAccess.post(
            bool ? Constants.URLs.ENABLE_YOUTUBE_CHANNEL : Constants.URLs.DISABLE_YOUTUBE_CHANNEL, {
                "user_id": props.auth.userId,
                "linked_youtube_channel_id": contentId
            })
            .then((response) => {
                const successJson = response.data;
                setLoading(false);
                toggleEnableModal(false)
                toggleDisableModal(false)
                successJson?.data && setList(successJson?.data);
            })
            .catch((error) => {
                console.log(error);
                setErrorMessage(error?.response?.data?.message ? error.response.data.message : "不明なエラーが発生しました");
                setAlertModalParam(true)
            });
    }

    const createItem = () => {
        apiAccess.post(
            Constants.URLs.ADD_YOUTUBE_CHANNEL, {
                "youtube_channel_id": channelIdInput
            })
            .then((response) => {
                const successJson = response.data;
                setLoading(false);
                toggleCreateModal(false);
                successJson?.data && setList(successJson?.data);
            })
            .catch((error) => {
                setErrorMessage(error?.response?.data?.message ? error.response.data.message : "不明なエラーが発生しました");
                setAlertModalParam(true)
            });
    }


    const toggleEnableModal = (bool) => {
        setEnableModalParam(bool)
    }
    const toggleDisableModal = (bool) => {
        setDisableModalParam(bool)
    }
    const toggleCreateModal = (bool) => {
        setCreateModalParam(bool)
    }
    const toggleAlertModal = (bool) =>{
        setAlertModalParam(bool)
    }

    return (
        <div>
            <div className={"console_wrapper"}>
                <Button
                    variant="contained"
                    startIcon={<CreateIcon />}
                    color={"primary"}
                    disableElevation
                    onClick={() => { toggleCreateModal(true); }}
                >
                    新規登録
                </Button>
            </div>
            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                <TableContainer sx={{ maxHeight: window.innerHeight }}>
                    {loading ?
                        <Spinner/> :
                        <Table aria-label="youtube list table">
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{background:"#f8f8f8"}}>名前</TableCell>
                                    <TableCell sx={{background:"#f8f8f8"}}>詳細</TableCell>
                                    <TableCell className={"table_cell_datetime"} sx={{background:"#f8f8f8"}}>追加日</TableCell>
                                    <TableCell className={"table_cell_enable_check"} sx={{background:"#f8f8f8"}}/>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {list.map((value, index) => (
                                    <TableRow key={index}>
                                        <TableCell component="th" scope="row">
                                            {value.linked_youtube_channel_title}
                                        </TableCell>
                                        <TableCell>{value.linked_youtube_channel_description}</TableCell>
                                        <TableCell>{value.linked_youtube_channel_linked_datetime}</TableCell>
                                        <TableCell align={"right"} >
                                            {value.linked_youtube_channel_enabled ?
                                                <IconButton aria-label="delete" color="primary" onClick={() => {
                                                    setContentId(value.linked_youtube_channel_id)
                                                    toggleDisableModal(true);
                                                }}>
                                                    <CheckBoxIcon/>
                                                </IconButton>
                                                :
                                                <IconButton aria-label="delete" color="primary" onClick={() => {
                                                    setContentId(value.linked_youtube_channel_id)
                                                    toggleEnableModal(true);
                                                }}>
                                                    <CheckBoxOutlineBlankIcon/>
                                                </IconButton>
                                            }
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    }
                </TableContainer>
            </Paper>


            <Dialog
                open={isCreateOpen}
                onClose={() => toggleCreateModal(false)}
                aria-labelledby="form-dialog-title"
                maxWidth={"sm"}
                fullWidth={true}
            >
                <DialogTitle>新規追加</DialogTitle>
                <DialogContent>
                    <DialogContentText>YouTubeチャンネルIDを入力してください</DialogContentText>
                    <TextField
                        autoFocus
                        id="outlined-youtube-channel-id-input"
                        label="YouTubeチャンネルID"
                        type="text"
                        fullWidth
                        margin="normal"
                        autoComplete="current-password"
                        variant="outlined"
                        value={channelIdInput}
                        onChange={(e)=>{setChannelIdInput(e.target.value)}}
                    />
                </DialogContent>
                <DialogActions>
                    <Button size={"large"}  onClick={() => toggleCreateModal(false)} color="primary">
                        キャンセル
                    </Button>
                    <Button size={"large"}  variant="contained"
                            onClick={()=>{
                                channelIdInput && createItem();
                            }}
                            color="primary">
                        追加
                    </Button>
                </DialogActions>
            </Dialog>


            <Dialog
                open={isAlertOpen}
                onClose={() => toggleAlertModal(false)}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <DialogTitle>{"エラー"}</DialogTitle>
                <DialogContent>
                    <DialogContentText>{errorMessage}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => toggleAlertModal(false)} color="primary">
                        閉じる
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={isDisableOpen}
                onClose={() => toggleDisableModal(false)}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <DialogTitle>{"無効化の確認"}</DialogTitle>
                <DialogContent>
                    <DialogContentText>選択したYouTubeチャンネルからの情報取得を無効にしますが、よろしいですか</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => toggleDisableModal(false)} color="primary">
                        キャンセル
                    </Button>
                    <Button variant="contained" onClick={() => toggleItemChange(false)} color="primary">
                        無効にする
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={isEnableOpen}
                onClose={() => toggleEnableModal(false)}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <DialogTitle >{"有効化の確認"}</DialogTitle>
                <DialogContent>
                    <DialogContentText>選択したYouTubeチャンネルからの情報取得を有効にしますが、よろしいですか</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => toggleEnableModal(false)} color="primary">
                        キャンセル
                    </Button>
                    <Button onClick={() => toggleItemChange(true)} color="primary"　variant="contained">
                        有効にする
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default YouTube;